<template>
  <div v-if="showPopup" class="popFixed">
    <div class="masking" @click="closePopup" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>为保障您的账号安全，请存款前完善您的个人资料，同时可享受更多通道的便利。</p>
      </div>
      <div class="btnCon">
        <span style="font-weight: bold" @click="goToAccUpdatePersonalData">去添加</span>
        <span style="color: #333; font-weight: normal" @click="skip">跳过</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccUpdatePersonalDataPopup',
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      showPopup: this.show
    }
  },
  watch: {
    show: function(newVal) {
      this.showPopup = newVal
    }
  },
  methods: {
    skip() {
      this.showPopup = false
      this.$emit('onSkip')
    },
    goToAccUpdatePersonalData() {
      this.$router.push({ path: '/home/accUpdatePersonalData' })
    },
    closePopup() {
      if (this.$route.path !== '/home') {
        this.skip()
        return
      }

      this.showPopup = false
      this.$emit('onClose')
    }
  }
}
</script>
